import { Button, Card, Stepper } from '@/components/ui'
import { PlayIcon } from '@/components/icons'
import type { BreathingExercise } from '../exercises'
import { cycleSeconds } from '../timing'

export type ExerciseDetailProps = {
  exercise: BreathingExercise
  durationMinutes: number
  onDurationChange: (minutes: number) => void
  onStart: () => void
}

/** Per-exercise explanation screen with duration choice (1–5 minutes). */
export function ExerciseDetail({
  exercise,
  durationMinutes,
  onDurationChange,
  onStart,
}: ExerciseDetailProps) {
  return (
    <div className="breathing-detail">
      <Card padding="lg" className="breathing-detail__card">
        <h2 className="breathing-detail__title">{exercise.name}</h2>
        <p className="breathing-detail__explanation">{exercise.explanation}</p>
        <p className="breathing-detail__metaphor">{exercise.metaphor}</p>

        <div className="breathing-detail__pattern">
          <h3 className="breathing-detail__pattern-title">Het ritme</h3>
          <ol className="breathing-detail__phases">
            {exercise.phases.map((phase, index) => (
              <li key={`${phase.kind}-${phase.side ?? 'geen'}-${index}`}>
                <span className="breathing-detail__phase-label">{phase.announce}</span>
                <span className="breathing-detail__phase-seconds">{phase.seconds} sec</span>
              </li>
            ))}
          </ol>
          <p className="breathing-detail__cycle">Eén ronde duurt {cycleSeconds(exercise)} seconden.</p>
        </div>

        <div className="breathing-detail__duration">
          <Stepper
            label="Duur"
            value={durationMinutes}
            onChange={onDurationChange}
            min={1}
            max={5}
            unit="min"
          />
        </div>

        <Button variant="primary" size="lg" fullWidth onClick={onStart}>
          <span className="breathing-detail__start">
            <PlayIcon size={20} />
            Start oefening
          </span>
        </Button>
      </Card>
    </div>
  )
}
